<script setup>
import AcknowledgementModal from "@/components/kit/AcknowledgementModal.vue";
import useKit from "@/composables/useKit";
import {ref} from "vue";
import KitHelpModal from "@/components/kit/KitHelpModal.vue";

const {isSubscribedToKit} = useKit();

const emit = defineEmits(['close']);

const showConfirmModal = ref(true);

const handleContinue = () => {
  emit('close');
};

const handleShowHelpModal = () => {
  showConfirmModal.value = false;
};

const handleHelpClose = () => {
  emit('close');
}

</script>

<template>
  <AcknowledgementModal
    v-if="showConfirmModal && isSubscribedToKit"
    heading="Editing your assigned keyword pages? Let’s make sure it’s the right move 🤔"
    confirm-text="No, I’m happy with the sitemap"
    cancel-text="Yes, contact an account manager"
    @close="handleShowHelpModal"
    @dismiss="handleContinue"
    @confirm="handleContinue"
  >
    <p>
      Your keyword sitemap is a key part of the SEO strategy I built for you—it directs which pages I optimize and the changes I implement.
    </p>
    <p>
      Changing it can have a big impact, so I recommend chatting with one of my managers first. They can help guide any updates without disrupting your overall plan.
    </p>
  </AcknowledgementModal>
  <KitHelpModal
    v-if="!showConfirmModal && isSubscribedToKit"
    screen="sitemap"
    @close="handleHelpClose"
  />
</template>